import React, { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon } from '@/components';
import { RootStore, meeting } from '@/models';
import ActionBtn from '../ActionBtn';
import styles from './index.less';
import classNames from 'classnames';
import { Popover } from 'antd';
import ReactionPanel from '../../../ReactionPanel';
import { elkLog } from '@/utils/elkReport';

interface Props extends Partial<Pick<RootStore, 'meeting' | 'reaction'>> {
  meeting?: RootStore['meeting'];
  reaction?: RootStore['reaction'];
}
const ReactionBtn: React.FC<Props> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    reaction: store.reaction,
  };
})(
  observer((props) => {
    const { reaction } = props;
    const { formatMessage } = useIntl();
    const [emoReaction, setEmoReaction] = useState<boolean>(true);
    const openReaction = () => {
      elkLog('点击表情按钮');
      if (reaction?.cancelHanupVisible && reaction.reactionVisible) {
        reaction?.setCancelHanupVisible(false);
        return;
      }
      if (!reaction?.cancelHanupVisible && reaction?.handUp && reaction.reactionVisible) {
        reaction?.setCancelHanupVisible(true);
        return;
      }
      reaction?.setReactionVisible(!reaction?.reactionVisible);
    };

    useEffect(() => {
      if (meeting?.info?.channelId && reaction?.reactionVisible) {
        API.api.reaction.getReactionStatus
          .request({
            channelId: meeting?.info?.channelId,
          })
          .then((res) => {
            setEmoReaction(!!res.data?.emoticonReactionEnabled);
          })
          .catch((err) => {
            console.log('/api/bs-vmeeting/web/v3/meeting/reaction', err);
          });
      }
    }, [meeting?.info?.channelId, reaction?.reactionVisible]);

    return (
      <Popover
        overlayClassName="oj7YZbAO5p"
        autoAdjustOverflow
        getPopupContainer={() => document?.getElementById('reactionBtn')!}
        placement="top"
        align={{ offset: [0, 12] }}
        open={reaction?.reactionVisible}
        content={<ReactionPanel hostEnableEmoList={emoReaction} />}
        trigger={['click']}
      >
        <ActionBtn
          id="reactionBtn"
          title={formatMessage({ id: 'reaction' })}
          className={classNames(
            styles.ReactionBtn,
            reaction?.reactionVisible && !reaction?.cancelHanupVisible ? styles.on : ''
          )}
          onClick={openReaction}
        >
          <Icon className={styles.icon} name="icon-emoji_solid_1" size={24} mode="symbol" />
        </ActionBtn>
      </Popover>
    );
  })
);

export default ReactionBtn;
